// T2-B event tracking admin dashboard API client (2026-05-04 PR 6b).
// Backend: omikuji-api PR 6a (#86) で実装、本番反映済 (api SHA eeef487+)。
//
// auth: ADMIN 必須 (= backend が enforce)
// 全 endpoint に row hard cap (1000) 設置済。

import ApiService from './ApiService';

export interface StatsParams {
    user_id?: number,
    year_month_from?: string, // YYYY-MM
    year_month_to?: string
}

export interface AggregateParams {
    event_type?: string,
    from?: string, // ISO 8601
    to?: string,
    group_by?: 'day' | 'month' | 'event_type' | 'user' | 'landmark' | 'motif' | 'fortune'
}

export interface TopParams {
    metric: 'motif' | 'landmark' | 'sponsor',
    from?: string,
    to?: string,
    limit?: number
}

export default class UserEventsAdminApi extends ApiService {
    stats(payload: StatsParams = {}) {
        return this.get('user-events/stats', payload);
    }

    aggregate(payload: AggregateParams = {}) {
        return this.get('user-events/aggregate', payload);
    }

    top(payload: TopParams) {
        return this.get('user-events/top', payload);
    }
}
